import React from 'react';
import { Badge, Radio } from 'antd';
import { EInboundStatus } from '@/enums/EInbound';
import { getInboundStatusName } from '@/helpers/inbouldHelper';
import { IInboundCount } from '@/interfaces/inbound';

interface InboundTabsProps {
  status?: EInboundStatus;
  onChange: (value: EInboundStatus) => void;
  data?: IInboundCount;
}

const InboundTabs: React.FC<InboundTabsProps> = ({
  status,
  onChange,
  data,
}) => {
  return (
    <Radio.Group
      size="large"
      value={status}
      onChange={e => onChange(e.target.value)}
      buttonStyle="solid"
    >
      <Radio.Button value={undefined}>
        <div className="flex items-center gap-1">ทั้งหมด</div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.PENDING}>
        <div className="flex items-center gap-2">
          {getInboundStatusName(EInboundStatus.PENDING)}
          <Badge count={data?.pending || 0} />
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.OPEN}>
        <div className="flex items-center gap-2">
          {getInboundStatusName(EInboundStatus.OPEN)}
          <Badge count={data?.open || 0} />
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.SEND}>
        <div className="flex items-center gap-2">
          {getInboundStatusName(EInboundStatus.SEND)}
          <Badge count={data?.send || 0} />
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.PARTIAL}>
        <div className="flex items-center gap-2">
          {getInboundStatusName(EInboundStatus.PARTIAL)}
          <Badge count={data?.partial || 0} />
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.COMPLETED}>
        <div className="flex items-center gap-2">
          {getInboundStatusName(EInboundStatus.COMPLETED)}
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.VOID}>
        <div className="flex items-center gap-1">
          {getInboundStatusName(EInboundStatus.VOID)}
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.SEND_ERROR}>
        <div className="flex items-center gap-1">
          {getInboundStatusName(EInboundStatus.SEND_ERROR)}
          <Badge count={data?.sendError || 0} />
        </div>
      </Radio.Button>
      <Radio.Button value={EInboundStatus.ERROR}>
        <div className="flex items-center gap-1">
          {getInboundStatusName(EInboundStatus.ERROR)}
          <Badge count={data?.error || 0} />
        </div>
      </Radio.Button>
    </Radio.Group>
  );
};

export default InboundTabs;
